import { boolean, RequestKind, string } from '@sb/library/base';
import { DisplayItemCollection, ReportDisplayItem, ReportInputItem, ReportSearchOptions } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace ReportsRoutes {
    export const Add = ApiRoute.Define({
        URL: `reports`,
        Kind: RequestKind.Post,
        ResultType: string,
        BodyType: ReportInputItem
    });

    export const Delete = ApiRoute.Define({
        URL: (reportID: string) => `reports/${reportID}`,
        Kind: RequestKind.Delete,
        ResultType: boolean
    });

    export const Get = ApiRoute.Define({
        URL: (reportID: string) => `reports/${reportID}`,
        Kind: RequestKind.Get,
        ResultType: ReportDisplayItem
    });

    export const Search = ApiRoute.Define({
        URL: `search/reports`,
        Kind: RequestKind.Post,
        BodyType: ReportSearchOptions,
        PagingAllowed: true,
        ResultType: DisplayItemCollection<ReportDisplayItem>,
        OrderByType: ReportDisplayItem,
        Cancellable: false
    });
}
